(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Armatupack"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('chclean-pack-visual')) return;

    class ChCleanPackVisual extends HTMLElement {
      constructor() {
        super();
        this.rows = [];
        this.tiers = [];
        this.busy = false;
      }

      connectedCallback() {
        this.rows = Array.from(this.querySelectorAll('[data-product-row]'));
        this.tierCards = Array.from(this.querySelectorAll('[data-tier-card]'));
        this.addButtons = Array.from(this.querySelectorAll('[data-add-pack]'));
        this.addButton = this.addButtons[0] || null;
        this.summaryCounts = Array.from(this.querySelectorAll('[data-summary-count]'));
        this.summaryThumbs = Array.from(this.querySelectorAll('[data-summary-thumbs]'));
        this.subtotalEls = Array.from(this.querySelectorAll('[data-subtotal]'));
        this.discountPercentEls = Array.from(this.querySelectorAll('[data-discount-percent]'));
        this.discountAmountEls = Array.from(this.querySelectorAll('[data-discount-amount]'));
        this.progressTitle = this.querySelector('[data-progress-title]');
        this.progressMessage = this.querySelector('[data-progress-message]');
        this.progressFill = this.querySelector('[data-progress-fill]');
        this.progressCount = this.querySelector('[data-progress-count]');
        this.inlineStatus = this.querySelector('[data-inline-status]');
        this.mobileDock = this.querySelector('[data-mobile-dock]');
        this.mobileDockCount = this.querySelector('[data-mobile-dock-count]');
        this.mobileDockSaving = this.querySelector('[data-mobile-dock-saving]');
        this.mobileDockNext = this.querySelector('[data-mobile-dock-next]');
        this.mobileDockFill = this.querySelector('[data-mobile-dock-fill]');
        this.primarySummary = this.querySelector('.chpack__visual-column > .chpack__summary');
        this.mobileDockRaf = null;

        this.readTiers();
        this.bindProducts();
        this.bindRecommended();
        this.addButtons.forEach(button => button.addEventListener('click', () => this.addSelectedPack(button)));
        this.setupMobileDock();
        this.render();
      }

      disconnectedCallback() {
        if (this.mobileDockAbort) this.mobileDockAbort.abort();
        if (this.mobileDockRaf) cancelAnimationFrame(this.mobileDockRaf);
      }

      setupMobileDock() {
        if (!this.mobileDock) return;
        this.mobileDockAbort = new AbortController();
        const options = { passive: true, signal: this.mobileDockAbort.signal };
        const requestUpdate = () => {
          if (this.mobileDockRaf) return;
          this.mobileDockRaf = requestAnimationFrame(() => {
            this.mobileDockRaf = null;
            this.updateMobileDockVisibility();
          });
        };

        window.addEventListener('scroll', requestUpdate, options);
        window.addEventListener('resize', requestUpdate, options);
        requestUpdate();
      }

      updateMobileDockVisibility() {
        if (!this.mobileDock) return;

        const isMobile = window.matchMedia('(max-width: 620px)').matches;
        if (!isMobile) {
          this.setMobileDockVisible(false);
          return;
        }

        const sectionRect = this.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const dockHeight = this.mobileDock.offsetHeight || 78;
        const stopBeforeNextSection = dockHeight + 18;

        const sectionIsOnScreen = sectionRect.top < viewportHeight && sectionRect.bottom > 0;
        const hasRoomInsideSection = sectionRect.bottom > stopBeforeNextSection;

        let mainSummaryPassed = true;
        if (this.primarySummary) {
          const summaryRect = this.primarySummary.getBoundingClientRect();
          mainSummaryPassed = summaryRect.bottom < 72;
        }

        this.setMobileDockVisible(sectionIsOnScreen && hasRoomInsideSection && mainSummaryPassed);
      }

      setMobileDockVisible(visible) {
        if (!this.mobileDock) return;
        this.mobileDock.classList.toggle('is-visible', visible);
        this.mobileDock.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }

      readTiers() {
        const script = this.querySelector('[data-pack-tiers]');
        try {
          this.tiers = JSON.parse(script?.textContent || '[]')
            .map(tier => ({
              qty: Number(tier.qty || 0),
              percent: Math.max(0, Number(tier.percent || 0)),
              code: String(tier.code || '').trim()
            }))
            .filter(tier => tier.qty > 0)
            .sort((a, b) => a.qty - b.qty);
        } catch (error) {
          console.warn('CH Clean Pack: no se pudieron leer los tramos.', error);
          this.tiers = [];
        }
      }

      bindProducts() {
        this.rows.forEach(row => {
          row.dataset.qty = row.dataset.qty || '0';
          row.querySelector('[data-plus]')?.addEventListener('click', () => this.changeQty(row, 1));
          row.querySelector('[data-minus]')?.addEventListener('click', () => this.changeQty(row, -1));
          row.querySelector('[data-variant-select]')?.addEventListener('change', event => {
            const option = event.target.options[event.target.selectedIndex];
            row.dataset.variantId = option.value;
            row.dataset.price = option.dataset.price || '0';
            row.dataset.variantTitle = option.dataset.title || '';
            const priceEl = row.querySelector('[data-product-price]');
            if (priceEl) priceEl.textContent = this.money(Number(row.dataset.price || 0));
            this.render();
          });
        });
      }

      bindRecommended() {
        this.querySelectorAll('[data-rec-add]').forEach(button => {
          button.addEventListener('click', async () => {
            if (this.busy || button.disabled) return;
            const variantId = Number(button.dataset.variantId || 0);
            if (!variantId) return;
            await this.addItems([{ id: variantId, quantity: 1, properties: { _Pack: button.dataset.recName || 'Pack recomendado CH Clean' } }], button);
          });
        });
      }

      changeQty(row, delta) {
        const current = Number(row.dataset.qty || 0);
        row.dataset.qty = String(Math.max(0, current + delta));
        this.render();
      }

      getSelectedRows() {
        return this.rows
          .map(row => ({
            row,
            quantity: Number(row.dataset.qty || 0),
            variantId: Number(row.dataset.variantId || 0),
            price: Number(row.dataset.price || 0),
            productTitle: row.dataset.productTitle || '',
            image: row.querySelector('.chpack__product-image')?.currentSrc || row.querySelector('.chpack__product-image')?.src || ''
          }))
          .filter(item => item.quantity > 0 && item.variantId > 0);
      }

      itemCount() {
        return this.getSelectedRows().reduce((sum, item) => sum + item.quantity, 0);
      }

      subtotal() {
        return this.getSelectedRows().reduce((sum, item) => sum + (item.price * item.quantity), 0);
      }

      activeTier(count) {
        return this.tiers.reduce((active, tier) => count >= tier.qty ? tier : active, null);
      }

      nextTier(count) {
        return this.tiers.find(tier => count < tier.qty) || null;
      }

      render() {
        const count = this.itemCount();
        const subtotal = this.subtotal();
        const activeTier = this.activeTier(count);
        const nextTier = this.nextTier(count);
        const percent = activeTier?.percent || 0;
        const discount = Math.round(subtotal * percent / 100);
        const maxTierQty = Math.max(...this.tiers.map(tier => tier.qty), 1);

        this.rows.forEach(row => {
          const qty = Number(row.dataset.qty || 0);
          row.classList.toggle('is-selected', qty > 0);
          const qtyEl = row.querySelector('[data-qty]');
          if (qtyEl) qtyEl.textContent = String(qty);
        });

        this.tierCards.forEach(card => {
          const qty = Number(card.dataset.tierQty || 0);
          card.classList.toggle('is-reached', count >= qty);
          card.classList.toggle('is-next', !!nextTier && qty === nextTier.qty);
        });

        this.summaryCounts.forEach(el => el.textContent = String(count));
        if (this.progressCount) this.progressCount.textContent = String(count);
        this.subtotalEls.forEach(el => el.textContent = this.money(subtotal));
        this.discountPercentEls.forEach(el => el.textContent = `${percent}%`);
        this.discountAmountEls.forEach(el => el.textContent = `−${this.money(discount)}`);
        const progressPercent = Math.min(100, count / maxTierQty * 100);
        if (this.progressFill) this.progressFill.style.width = `${progressPercent}%`;
        if (this.mobileDockFill) this.mobileDockFill.style.width = `${progressPercent}%`;
        if (this.mobileDockCount) this.mobileDockCount.textContent = String(count);
        if (this.mobileDockSaving) this.mobileDockSaving.textContent = percent > 0 ? `${percent}% ahorro` : 'Sin descuento aún';

        if (this.mobileDockNext) {
          if (nextTier) {
            const missingForNext = Math.max(0, nextTier.qty - count);
            this.mobileDockNext.textContent = `${missingForNext} ${missingForNext === 1 ? 'producto más' : 'productos más'} para ${nextTier.percent}% de ahorro`;
          } else if (activeTier) {
            this.mobileDockNext.textContent = `Máximo ahorro desbloqueado: ${activeTier.percent}%`;
          } else {
            this.mobileDockNext.textContent = 'Agrega productos para desbloquear tu descuento';
          }
        }

        this.renderThumbs();
        this.renderProgressText(count, activeTier, nextTier);
        this.renderButton(count);
        this.updateMobileDockVisibility();
      }

      renderThumbs() {
        if (!this.summaryThumbs.length) return;
        const selected = this.getSelectedRows();

        this.summaryThumbs.forEach(container => {
          container.replaceChildren();
          selected.slice(0, 4).forEach(item => {
            const img = document.createElement('img');
            img.className = 'chpack__thumb';
            img.src = item.image;
            img.alt = '';
            img.loading = 'lazy';
            container.appendChild(img);
          });

          const empty = document.createElement('span');
          empty.className = 'chpack__thumb-empty';
          empty.textContent = selected.length > 4 ? `+${selected.length - 4}` : '+';
          container.appendChild(empty);
        });
      }

      renderProgressText(count, activeTier, nextTier) {
        const replace = (source, values) => String(source || '').replace(/\{(\w+)\}/g, (match, key) => Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match);
        let message = this.dataset.emptyText || 'Agrega productos para comenzar.';
        if (nextTier) {
          message = replace(this.dataset.nextText || 'Agrega {count} más y obtén {percent}% de ahorro.', {
            count: Math.max(0, nextTier.qty - count),
            percent: nextTier.percent
          });
        } else if (activeTier) {
          message = replace(this.dataset.unlockedText || '¡Desbloqueaste {percent}% de descuento!', {
            percent: activeTier.percent,
            count
          });
        }
        if (this.progressMessage) this.progressMessage.textContent = message;
      }

      renderButton(count) {
        if (!this.addButtons.length) return;
        const minimum = Number(this.dataset.minimum || 1);
        const missing = Math.max(0, minimum - count);

        this.addButtons.forEach(button => {
          const label = button.querySelector('[data-add-pack-label]');
          button.disabled = this.busy || count < minimum;
          if (!label) return;

          if (this.busy) {
            label.textContent = this.dataset.loadingText || 'Agregando…';
          } else if (missing > 0) {
            label.textContent = (this.dataset.minimumButton || 'Agrega {count} más').replace('{count}', String(missing));
          } else {
            label.textContent = this.dataset.cartLabel || 'Agregar al pack';
          }
        });
      }

      money(cents) {
        const currency = this.dataset.currency || 'CLP';
        const locale = this.dataset.locale || 'es-CL';
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            maximumFractionDigits: currency === 'CLP' ? 0 : 2
          }).format(Number(cents || 0) / 100);
        } catch (error) {
          return `$${Math.round(Number(cents || 0) / 100).toLocaleString('es-CL')}`;
        }
      }

      async addSelectedPack(triggerButton = this.addButton) {
        if (this.busy) return;
        const selected = this.getSelectedRows();
        const minimum = Number(this.dataset.minimum || 1);
        if (this.itemCount() < minimum || selected.length === 0) return;

        const items = selected.map(item => ({
          id: item.variantId,
          quantity: item.quantity,
          properties: { _Pack: this.dataset.packName || 'Arma tu pack CH Clean' }
        }));
        await this.addItems(items, triggerButton || this.addButton, true);
      }

      async addItems(items, triggerButton, fromBuilder = false) {
        this.busy = true;
        if (this.inlineStatus) this.inlineStatus.textContent = '';
        if (triggerButton) triggerButton.disabled = true;
        this.renderButton(this.itemCount());

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.description || data.message || 'No se pudo agregar al carrito.');
          }

          const count = this.itemCount();
          const activeTier = this.activeTier(count);
          const discountMode = this.dataset.discountMode || 'automatic';
          const afterAdd = this.dataset.afterAdd || 'drawer';

          if (discountMode === 'codes' && activeTier?.code) {
            const destination = afterAdd === 'checkout' ? `${root}checkout` : `${root}cart`;
            window.location.href = `${root}discount/${encodeURIComponent(activeTier.code)}?redirect=${encodeURIComponent(destination)}`;
            return;
          }

          if (afterAdd === 'checkout') {
            window.location.href = `${root}checkout`;
            return;
          }

          if (afterAdd === 'cart') {
            window.location.href = `${root}cart`;
            return;
          }

          await this.refreshAndOpenDrawer();

          if (fromBuilder) {
            this.rows.forEach(row => row.dataset.qty = '0');
            if (this.inlineStatus) this.inlineStatus.textContent = this.dataset.successText || 'Pack agregado al carrito.';
          }
        } catch (error) {
          console.error('CH Clean Pack:', error);
          if (this.inlineStatus) this.inlineStatus.textContent = `${this.dataset.errorText || 'No pudimos agregar el pack.'} ${error.message || ''}`.trim();
        } finally {
          this.busy = false;
          this.render();
          if (triggerButton && triggerButton.matches('[data-rec-add]')) triggerButton.disabled = false;
        }
      }

      async refreshAndOpenDrawer() {
        const root = window.Shopify?.routes?.root || '/';
        let refreshed = false;

        try {
          const sectionResponse = await fetch(`${root}?sections=cart-drawer-section`, { headers: { 'Accept': 'application/json' } });
          if (sectionResponse.ok) {
            const sections = await sectionResponse.json();
            const html = sections['cart-drawer-section'];
            if (html) {
              const temp = document.createElement('div');
              temp.innerHTML = html;
              const nextSection = temp.querySelector('#shopify-section-cart-drawer-section');
              const currentSection = document.querySelector('#shopify-section-cart-drawer-section');
              if (nextSection && currentSection) {
                currentSection.replaceWith(nextSection);
                refreshed = true;
              }
            }
          }
        } catch (error) {
          console.warn('CH Clean Pack: no se pudo refrescar el drawer.', error);
        }

        try {
          if (customElements.get('cart-drawer-component')) {
            const drawerComponent = document.querySelector('cart-drawer-component');
            if (drawerComponent && typeof drawerComponent.open === 'function') {
              drawerComponent.open();
              return;
            }
          }

          const themeDrawer = document.querySelector('#cart-drawer');
          if (themeDrawer && typeof themeDrawer.open === 'function') {
            themeDrawer.open();
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'chclean-pack' } }));
          document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true, detail: { refreshed } }));
        } catch (error) {
          console.warn('CH Clean Pack: el drawer no pudo abrirse.', error);
        }
      }
    }

    customElements.define('chclean-pack-visual', ChCleanPackVisual);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chclean-pack-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('chclean-pack-builder')) return;

    class ChcleanPackBuilder extends HTMLElement {
      constructor() {
        super();
        this.selections = new Map();
        this.tiers = [];
        this.isSubmitting = false;
      }

      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-pack-card]'));
        this.selectedList = this.querySelector('[data-pack-selected-list]');
        this.emptyText = this.querySelector('[data-pack-empty]')?.textContent || '';
        this.selectedCount = this.querySelector('[data-pack-selected-count]');
        this.subtotalEl = this.querySelector('[data-pack-subtotal]');
        this.discountEl = this.querySelector('[data-pack-discount]');
        this.totalEl = this.querySelector('[data-pack-total]');
        this.percentEl = this.querySelector('[data-pack-percent]');
        this.tierMessage = this.querySelector('[data-pack-tier-message]');
        this.progressFill = this.querySelector('[data-pack-progress-fill]');
        this.progressMarks = this.querySelector('[data-pack-progress-marks]');
        this.cartButton = this.querySelector('[data-pack-cart]');
        this.cartButtonLabel = this.querySelector('[data-pack-cart-label]');
        this.statusEl = this.querySelector('[data-pack-status]');
        this.filtersEl = this.querySelector('[data-pack-filters]');

        this.readTiers();
        this.bindCards();
        this.buildFilters();
        this.renderProgressMarks();
        this.render();
      }

      readTiers() {
        const node = this.querySelector('[data-pack-tiers]');
        if (!node) return;
        try {
          this.tiers = JSON.parse(node.textContent || '[]')
            .map((tier) => ({
              qty: Number(tier.qty) || 0,
              percent: Math.max(0, Number(tier.percent) || 0),
              code: String(tier.code || '').trim(),
              label: String(tier.label || '').trim()
            }))
            .filter((tier) => tier.qty > 0)
            .sort((a, b) => a.qty - b.qty);
        } catch (error) {
          console.warn('CH Clean Pack: error leyendo tramos.', error);
          this.tiers = [];
        }
      }

      bindCards() {
        this.cards.forEach((card) => {
          card.querySelector('[data-pack-toggle]')?.addEventListener('click', () => this.toggleCard(card));
          const select = card.querySelector('[data-pack-variant]');
          select?.addEventListener('change', () => this.handleVariantChange(card, select));
        });
        this.cartButton?.addEventListener('click', () => this.addPackToCart());
      }

      buildFilters() {
        if (!this.filtersEl || this.dataset.showFilters !== 'true') return;
        const categories = [...new Set(this.cards.map((card) => (card.dataset.category || '').trim()).filter(Boolean))];
        if (categories.length < 2) return;

        const options = [{ value: '__all__', label: this.dataset.filterAll || 'Todos' }, ...categories.map((c) => ({ value: c, label: c }))];
        this.filtersEl.hidden = false;
        this.filtersEl.replaceChildren();

        options.forEach((option, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `ch-pack__filter${index === 0 ? ' is-active' : ''}`;
          button.textContent = option.label;
          button.addEventListener('click', () => {
            this.filtersEl.querySelectorAll('.ch-pack__filter').forEach((b) => b.classList.toggle('is-active', b === button));
            this.cards.forEach((card) => {
              card.hidden = option.value !== '__all__' && (card.dataset.category || '') !== option.value;
            });
          });
          this.filtersEl.appendChild(button);
        });
      }

      handleVariantChange(card, select) {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        const price = Number(option.dataset.price || 0);
        const compareAt = Number(option.dataset.compareAt || 0);
        const variantTitle = option.dataset.variantTitle || '';

        card.dataset.variantId = option.value;
        card.dataset.price = String(price);
        card.dataset.variantTitle = variantTitle;
        const priceEl = card.querySelector('[data-pack-price]');
        const compareEl = card.querySelector('[data-pack-compare-price]');
        if (priceEl) priceEl.textContent = this.money(price);
        if (compareEl) {
          compareEl.hidden = compareAt <= price;
          compareEl.textContent = compareAt > price ? this.money(compareAt) : '';
        }

        const key = card.dataset.key;
        if (key && this.selections.has(key)) {
          const item = this.selections.get(key);
          item.variantId = option.value;
          item.price = price;
          item.variantTitle = variantTitle;
          this.selections.set(key, item);
          this.render();
        }
      }

      toggleCard(card) {
        const key = card.dataset.key;
        if (!key) return;
        if (this.selections.has(key)) {
          this.selections.delete(key);
        } else {
          const img = card.querySelector('.ch-pack__product-image');
          this.selections.set(key, {
            key,
            variantId: String(card.dataset.variantId || ''),
            productTitle: String(card.dataset.productTitle || ''),
            variantTitle: String(card.dataset.variantTitle || ''),
            price: Number(card.dataset.price || 0),
            image: img?.currentSrc || img?.src || '',
            quantity: 1
          });
        }
        this.render();
      }

      metricCount() {
        if (this.dataset.countMode === 'unique') return this.selections.size;
        return Array.from(this.selections.values()).reduce((sum, item) => sum + item.quantity, 0);
      }

      subtotal() {
        return Array.from(this.selections.values()).reduce((sum, item) => sum + item.price * item.quantity, 0);
      }

      activeTier(count) {
        let active = null;
        this.tiers.forEach((tier) => { if (count >= tier.qty) active = tier; });
        return active;
      }

      nextTier(count) {
        return this.tiers.find((tier) => count < tier.qty) || null;
      }

      render() {
        const count = this.metricCount();
        const subtotal = this.subtotal();
        const activeTier = this.activeTier(count);
        const percent = activeTier?.percent || 0;
        const discount = Math.round(subtotal * percent / 100);
        const total = Math.max(0, subtotal - discount);
        const minimum = Number(this.dataset.minSelection || 1);

        this.syncCards();
        this.renderSelectedItems();
        this.renderTierMessage(count, activeTier);
        this.updateProgress(count);

        if (this.selectedCount) this.selectedCount.textContent = `${count} ${this.dataset.selectedCountText || 'productos'}`;
        if (this.subtotalEl) this.subtotalEl.textContent = this.money(subtotal);
        if (this.discountEl) this.discountEl.textContent = `- ${this.money(discount)}`;
        if (this.totalEl) this.totalEl.textContent = this.money(total);
        if (this.percentEl) this.percentEl.textContent = percent > 0 ? `(${percent}% OFF)` : '';

        if (this.cartButton) {
          const missing = Math.max(0, minimum - count);
          this.cartButton.disabled = this.isSubmitting || missing > 0 || this.selections.size === 0;
          if (!this.isSubmitting && this.cartButtonLabel) {
            this.cartButtonLabel.textContent = missing > 0
              ? this.template(this.dataset.buttonMinimum || 'Elige {count} más', { count: missing })
              : (this.dataset.buttonLabel || 'Agregar pack al carrito');
          }
        }
      }

      syncCards() {
        this.cards.forEach((card) => {
          const selected = this.selections.has(card.dataset.key);
          card.classList.toggle('is-selected', selected);
          const button = card.querySelector('[data-pack-toggle]');
          const text = card.querySelector('[data-pack-toggle-text]');
          button?.setAttribute('aria-pressed', selected ? 'true' : 'false');
          if (text) text.textContent = selected ? (this.dataset.addedLabel || 'Quitar del pack') : (this.dataset.addLabel || 'Agregar al pack');
        });
      }

      renderSelectedItems() {
        if (!this.selectedList) return;
        const items = Array.from(this.selections.values());
        this.selectedList.replaceChildren();
        if (items.length === 0) {
          const empty = document.createElement('p');
          empty.className = 'ch-pack__empty';
          empty.textContent = this.emptyText || 'Elige productos para comenzar tu pack.';
          this.selectedList.appendChild(empty);
          return;
        }

        items.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'ch-pack__selected-item';

          if (item.image) {
            const img = document.createElement('img');
            img.className = 'ch-pack__selected-thumb';
            img.src = item.image;
            img.alt = '';
            img.loading = 'lazy';
            row.appendChild(img);
          } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'ch-pack__selected-thumb';
            row.appendChild(placeholder);
          }

          const info = document.createElement('div');
          info.className = 'ch-pack__selected-info';
          const title = document.createElement('span');
          title.className = 'ch-pack__selected-title';
          title.textContent = item.productTitle;
          info.appendChild(title);

          if (item.variantTitle && item.variantTitle !== 'Default Title') {
            const variant = document.createElement('span');
            variant.className = 'ch-pack__selected-variant';
            variant.textContent = item.variantTitle;
            info.appendChild(variant);
          }

          const price = document.createElement('span');
          price.className = 'ch-pack__selected-price';
          price.textContent = this.money(item.price * item.quantity);
          info.appendChild(price);
          row.appendChild(info);

          const controls = document.createElement('div');
          const qty = document.createElement('div');
          qty.className = 'ch-pack__qty';

          const minus = document.createElement('button');
          minus.type = 'button';
          minus.textContent = '−';
          minus.setAttribute('aria-label', `Disminuir ${item.productTitle}`);
          minus.addEventListener('click', () => this.changeQuantity(item.key, -1));

          const amount = document.createElement('span');
          amount.textContent = String(item.quantity);

          const plus = document.createElement('button');
          plus.type = 'button';
          plus.textContent = '+';
          plus.setAttribute('aria-label', `Aumentar ${item.productTitle}`);
          plus.addEventListener('click', () => this.changeQuantity(item.key, 1));

          qty.append(minus, amount, plus);
          controls.appendChild(qty);

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'ch-pack__remove';
          remove.textContent = this.dataset.removeLabel || 'Quitar';
          remove.addEventListener('click', () => { this.selections.delete(item.key); this.render(); });
          controls.appendChild(remove);
          row.appendChild(controls);
          this.selectedList.appendChild(row);
        });
      }

      changeQuantity(key, delta) {
        const item = this.selections.get(key);
        if (!item) return;
        item.quantity += delta;
        if (item.quantity <= 0) this.selections.delete(key);
        else this.selections.set(key, item);
        this.render();
      }

      renderTierMessage(count, activeTier) {
        if (!this.tierMessage) return;
        const next = this.nextTier(count);
        let text = '';
        if (next) {
          text = this.template(this.dataset.nextTemplate || 'Agrega {count} más y desbloquea {percent}% OFF', { count: Math.max(0, next.qty - count), percent: next.percent });
        } else if (activeTier) {
          text = this.template(this.dataset.unlockedTemplate || '¡Desbloqueaste {percent}% de descuento!', { percent: activeTier.percent, count });
        } else {
          text = this.dataset.noTierText || '';
        }
        this.tierMessage.textContent = text;
      }

      renderProgressMarks() {
        if (!this.progressMarks || this.tiers.length === 0) return;
        const maxQty = Math.max(...this.tiers.map((tier) => tier.qty), 1);
        this.progressMarks.replaceChildren();
        this.tiers.forEach((tier) => {
          const mark = document.createElement('div');
          mark.className = 'ch-pack__mark';
          mark.dataset.qty = String(tier.qty);
          mark.style.left = `${Math.min(100, tier.qty / maxQty * 100)}%`;
          const dot = document.createElement('span');
          dot.className = 'ch-pack__mark-dot';
          dot.textContent = tier.label || `${tier.qty}+`;
          const label = document.createElement('span');
          label.className = 'ch-pack__mark-label';
          label.textContent = `${tier.percent}% OFF`;
          mark.append(dot, label);
          this.progressMarks.appendChild(mark);
        });
      }

      updateProgress(count) {
        if (!this.progressFill || this.tiers.length === 0) return;
        const maxQty = Math.max(...this.tiers.map((tier) => tier.qty), 1);
        this.progressFill.style.width = `${Math.max(0, Math.min(100, count / maxQty * 100))}%`;
        this.progressMarks?.querySelectorAll('.ch-pack__mark').forEach((mark) => mark.classList.toggle('is-reached', count >= Number(mark.dataset.qty || 0)));
      }

      template(source, values) {
        return String(source || '').replace(/\{(\w+)\}/g, (match, key) => Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match);
      }

      money(cents) {
        const currency = this.dataset.currency || 'CLP';
        const locale = this.dataset.locale || 'es-CL';
        const amount = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: currency === 'CLP' ? 0 : 2 }).format(amount);
        } catch (error) {
          return `$${Math.round(amount).toLocaleString('es-CL')}`;
        }
      }

      async addPackToCart() {
        if (this.isSubmitting || this.selections.size === 0) return;
        const count = this.metricCount();
        const minimum = Number(this.dataset.minSelection || 1);
        if (count < minimum) return;

        const activeTier = this.activeTier(count);
        const root = window.Shopify?.routes?.root || '/';
        const aggregate = new Map();
        this.selections.forEach((item) => {
          if (!item.variantId) return;
          aggregate.set(item.variantId, (aggregate.get(item.variantId) || 0) + item.quantity);
        });

        const items = Array.from(aggregate.entries()).map(([id, quantity]) => ({
          id: Number(id),
          quantity,
          properties: { _Pack: this.dataset.packName || 'Arma tu pack' }
        }));
        if (items.length === 0) return;

        this.isSubmitting = true;
        if (this.statusEl) this.statusEl.textContent = '';
        if (this.cartButton) this.cartButton.disabled = true;
        if (this.cartButtonLabel) this.cartButtonLabel.textContent = this.dataset.buttonLoading || 'Agregando…';

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error(data.description || data.message || 'No se pudo agregar el pack.');
          }

          const mode = this.dataset.discountMode || 'automatic';
          const afterAdd = this.dataset.afterAdd || 'cart';
          const destination = afterAdd === 'checkout' ? `${root}checkout` : `${root}cart`;
          const code = activeTier?.code || '';

          if (mode === 'codes' && code) {
            window.location.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(destination)}`;
            return;
          }

          if (afterAdd === 'stay') {
            if (this.statusEl) this.statusEl.textContent = this.dataset.successText || 'Pack agregado al carrito.';
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'chclean-pack-builder' } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            this.selections.clear();
            this.isSubmitting = false;
            this.render();
            return;
          }

          window.location.href = destination;
        } catch (error) {
          console.error('CH Clean Pack:', error);
          if (this.statusEl) this.statusEl.textContent = `${this.dataset.errorText || 'Ocurrió un error.'} ${error.message || ''}`.trim();
          this.isSubmitting = false;
          this.render();
        }
      }
    }

    customElements.define('chclean-pack-builder', ChcleanPackBuilder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
